import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { LoadingSpinerLocal } from '../../../../../../components';
import { selectorRuleCompositionOffer, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/ruleCompositionOffer';
import { CompositionRuleModal } from '../../CompositionRuleModal';

type RuleCompositionOfferModalWrapperProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const RuleCompositionOfferModalWrapper = ({ ruleCompositionOffer, closeModal }: RuleCompositionOfferModalWrapperProps) => {
  const { promiseInProgress } = usePromiseTracker({ area: 'composition-rule-offer' });

  if (promiseInProgress) {
    return <LoadingSpinerLocal loading={promiseInProgress} size="md" height="100%" position="absolute" />;
  }

  return <CompositionRuleModal show={ruleCompositionOffer.isOpen} onHide={closeModal} ruleComposition={ruleCompositionOffer.data} />;
};

const mapStateToProps = (state: RootState) => ({
  ruleCompositionOffer: selectorRuleCompositionOffer(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeModal: () => dispatch(SET_IS_OPEN(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RuleCompositionOfferModalWrapper);
